import { Grid, Typography, CircularProgress } from '@material-ui/core'
import { ReduxFormField } from '../../../../components/FormInput/ReduxWrappers'
import i18n from '../../../../translations/i18n'
import { MuiClasses } from '../../../../types'
import { isInvalidCharacters, required } from '../../../../utils/validation/forms'
import { MyTextArea } from '../../../NewApplication/Fields'

interface AdditionalInfoFieldsProps {
  t: i18n.TFunction
  isDisabled: boolean
  currentStep: any
  classes: MuiClasses
  isLoading?: boolean
}

const AdditionalInfoFields = ({
  t,
  isDisabled,
  currentStep,
  classes,
  isLoading
}: AdditionalInfoFieldsProps) => (
  <Grid container>
    <Grid container className={classes.containerItem}>
      <Grid item xs={12} sm={12}>
        <Typography variant='body1' gutterBottom>
          {t('apartment.list.information.additionalInformation')}
        </Typography>
        <div style={{ position: 'relative' }}>
          <ReduxFormField
            name='notes'
            multiline={true}
            disabled={isDisabled}
            component={MyTextArea}
            style={{
              width: '100%',
              height: '320px',
              padding: '20px',
              background: '#E7ECEF'
            }}
            placeholder={t('apartment.list.information.additionalInformationPlaceholder')}
            validate={[required, isInvalidCharacters]}
            required
          />
          {isLoading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none'
              }}
            >
              <CircularProgress />
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  </Grid>
)

export default AdditionalInfoFields
